/*
 * Scentt compare page \u2013 <scentt-compare-page data-max data-meter data-estimate data-conc \u2026>
 * (sections/scentt-compare-page.liquid). Rows = <li data-scentt-cmp-row="type" \u2026> blocks; product data
 * from ?section_id=scentt-compare-data, falling back to /products/<handle>.js.
 * Shares the handle list 'scentt:compare' with scentt-compare.js (toggles + bar).
 */
(() => {
  const start = () => {
    const S = window.Scentt && Object.isFrozen(window.Scentt) && typeof window.Scentt.html === 'function' ? window.Scentt : null;
    if (!S || customElements.get('scentt-compare-page')) return;
    const bar = () => document.querySelector('scentt-compare-bar');

    const LIMIT = 4;
    const picks = S.list('scentt:compare', LIMIT);
    const META_KEY = 'scentt:compare-meta';
    const H = (strings, ...values) => S.raw(S.html(strings, ...values));
    const safePath = (p, def) => (typeof p === 'string' && /^\/(?!\/)[^\s"'<>\\]*$/.test(p) ? p : def);
    const isImg = (u) => typeof u === 'string' && u.length < 800
      && (/^(https:)?\/\/[a-z0-9.-]+\/[^\s"'<>()\\]*$/i.test(u) || /^\/(?!\/)[^\s"'<>()\\]*$/.test(u));
    const preview = (sep) => {
      const t = window.Shopify && window.Shopify.theme;
      return t && t.role && t.role !== 'main' && S.isId(t.id) ? `${sep}preview_theme_id=${t.id}` : '';
    };
    const pretty = (h) => h.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    const maxAllowed = () => {
      const src = document.querySelector('scentt-compare-bar') || document.querySelector('scentt-compare-page');
      return S.int(src && src.dataset.max, 3, 2, LIMIT);
    };

    /* ---------- title / image cache (untrusted: validated on every read) ---------- */
    const readMeta = () => {
      const raw = S.store.get(META_KEY, (v) => v && typeof v === 'object' && !Array.isArray(v), {});
      const out = {};
      Object.keys(raw).slice(0, 20).forEach((h) => {
        const m = raw[h];
        if (!S.isHandle(h) || !m || typeof m !== 'object') return;
        out[h] = { t: typeof m.t === 'string' ? m.t.slice(0, 150) : '', i: isImg(m.i) ? m.i : '' };
      });
      return out;
    };
    const saveMeta = (h, title, image) => {
      const meta = readMeta();
      const keep = {};
      picks.all().forEach((x) => { if (meta[x]) keep[x] = meta[x]; });
      keep[h] = { t: String(title || '').slice(0, 150), i: isImg(image) ? image : '' };
      S.store.set(META_KEY, keep);
    };
    const metaFor = (h) => {
      const btn = document.querySelector(`[data-scentt-compare="${h}"][data-title]`);
      const m = readMeta()[h] || { t: '', i: '' };
      const image = btn && isImg(btn.getAttribute('data-image')) ? btn.getAttribute('data-image') : m.i;
      return { t: (btn && btn.getAttribute('data-title')) || m.t || pretty(h), i: image };
    };


    /* ---------- product data for the compare page ---------- */
    const split = (v) => String(v == null ? '' : v).split(/[|;,\n]/).map((x) => x.trim()).filter(Boolean).slice(0, 40).map((x) => x.slice(0, 80));
    const norm = (v) => String(v).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const titleCase = (v) => (v ? v.charAt(0).toUpperCase() + v.slice(1) : v);
    const uniq = (arr) => arr.filter((x, i) => arr.findIndex((y) => norm(y) === norm(x)) === i);
    const str = (v, max = 200) => (typeof v === 'string' ? v.slice(0, max) : typeof v === 'number' ? String(v) : '');
    const level = (v) => { const n = Math.round(S.num(v, 0)); return n >= 1 && n <= 5 ? n : 0; };

    const FAMILY = ['Woody', 'Floral', 'Amber', 'Oud', 'Spicy', 'Fruity', 'Sweet', 'Gourmand', 'Aromatic', 'Fresh', 'Citrus', 'Aquatic', 'Green', 'Leather', 'Musk', 'Powdery', 'Smoky'];
    const detectConc = (txt) => {
      const t = ` ${norm(txt).replace(/[^a-z0-9]+/g, ' ')} `;
      const tests = [['extrait', /extrait/], ['elixir', /elixir/], ['fraiche', /eau fraiche/], ['mist', /body mist|body spray/], ['attar', / attar | ittar /],
        ['oil', /perfume oil|concentrated oil/], ['intense', /eau de parfum intense| absolu /], ['edp', /eau de parfum| edp /], ['edt', /eau de toilette| edt /],
        ['edc', /eau de cologne| edc | cologne /], ['parfum', / parfum /]];
      const hit = tests.find((x) => x[1].test(t));
      return hit ? hit[0] : '';
    };

    /** Shape every product the same way, whatever the source; drops anything unexpected. */
    const normalize = (d, facts, handle) => {
      const variants = (Array.isArray(d.vs) ? d.vs : []).slice(0, 50).filter((v) => v && typeof v === 'object').map((v) => ({
        t: str(v.t, 120),
        o: (Array.isArray(v.o) ? v.o : []).slice(0, 3).map((o) => str(o, 80)),
        p: S.int(v.p, 0, 0),
        a: v.a === true,
      }));
      const mf = Object.create(null);
      if (d.mf && typeof d.mf === 'object' && !Array.isArray(d.mf)) {
        Object.keys(d.mf).slice(0, 21).forEach((k) => { if (/^[a-z0-9_]{1,60}$/.test(k) && k !== '_') mf[k] = str(d.mf[k], 300); });
      }
      const f = facts || {};
      return {
        handle,
        title: str(d.t, 200) || pretty(handle),
        vendor: str(d.v, 120),
        url: safePath(d.u, `/products/${handle}`),
        image: isImg(d.i) ? d.i : '',
        price: str(d.p, 60),
        compareAt: str(d.c, 60),
        available: d.a === true,
        coming: d.cs === true,
        variant: S.isId(d.id) ? String(d.id) : '',
        multi: d.m === true,
        conc: /^[a-z]{2,12}$/.test(d.k || '') ? d.k : '',
        concLabel: str(d.kl, 120),
        strength: level(d.st),
        longevity: level(d.lo),
        top: split(d.top),
        heart: split(d.heart),
        base: split(d.base),
        family: uniq([...split(f.family), ...split(d.fam)].map(titleCase)),
        forWho: split(f.for).map(titleCase),
        occasion: split(f.occasion).map(titleCase),
        season: split(f.season).map(titleCase),
        sizes: split(f.size),
        keyNotes: split(f.notes).map(titleCase),
        rating: Math.min(5, Math.max(0, S.num(d.r, 0))),
        ratingCount: S.int(d.rc, 0, 0),
        tags: (Array.isArray(d.tags) ? d.tags : []).slice(0, 250).map((t) => str(t, 80)).filter(Boolean),
        variants,
        mf,
      };
    };

    /** Backup when the theme's data section can't be read: Shopify's public product JSON. */
    const fromProductJs = (p, handle) => {
      const tags = (Array.isArray(p.tags) ? p.tags : []).map((t) => String(t));
      const lower = tags.map((t) => t.toLowerCase());
      const pick = (words) => words.filter((w) => lower.includes(w.toLowerCase()));
      const options = Array.isArray(p.options) ? p.options : [];
      const sizeOpt = options.findIndex((o) => /size|volume/i.test((o && o.name) || o));
      let img = typeof p.featured_image === 'string' ? p.featured_image : '';
      if (img) img += `${img.includes('?') ? '&' : '?'}width=600`;
      const vs = (Array.isArray(p.variants) ? p.variants : []);
      const first = vs.find((v) => v && v.available) || vs[0] || {};
      return normalize({
        t: p.title, v: p.vendor, u: p.url, i: img,
        p: S.money(p.price),
        c: p.compare_at_price > p.price ? S.money(p.compare_at_price) : '',
        a: p.available === true, id: first.id, m: vs.length > 1,
        k: detectConc(`${p.title} ${p.type || ''} ${tags.join(' ')}`),
        tags,
        vs: vs.map((v) => ({ t: v.title, o: v.options, p: v.price, a: v.available })),
      }, {
        family: pick(FAMILY).join('|'),
        for: pick(['For him', 'For her', 'Unisex']).join('|'),
        occasion: pick(['Day', 'Evening']).join('|'),
        season: pick(['Spring', 'Summer', 'Autumn', 'Winter']).join('|'),
        size: sizeOpt > -1 && options[sizeOpt] && Array.isArray(options[sizeOpt].values) ? options[sizeOpt].values.join('|') : '',
      }, handle);
    };

    const cache = new Map();
    /** Resolves to { data } | { gone: true } | { failed: true } \u2013 never rejects. */
    const loadProduct = (handle) => {
      if (cache.has(handle)) return cache.get(handle);
      const path = `/products/${encodeURIComponent(handle)}`;
      const job = S.fetchSection(`${path}${preview('?')}`, 'scentt-compare-data')
        .then((doc) => {
          const el = doc.querySelector('[data-scentt-cmp]');
          if (!el) throw new S.Error('no data');
          let raw = null;
          try { raw = JSON.parse(el.getAttribute('data-json') || ''); } catch (e) { raw = null; }
          if (!raw || typeof raw !== 'object' || Array.isArray(raw)) throw new S.Error('bad data');
          return { data: normalize(raw, el.dataset, handle) };
        })
        .catch((first) => S.fetchJSON(`${path}.js`)
          .then((p) => ({ data: fromProductJs(p, handle) }))
          .catch((second) => ((first && first.status === 404) || (second && second.status === 404) ? { gone: true } : { failed: true })));
      job.then((r) => { if (!r.data) cache.delete(handle); });
      cache.set(handle, job);
      return job;
    };

    /* ---------- price per ml ---------- */
    const mlOf = (s) => { const m = String(s || '').match(/(\d+(?:[.,]\d+)?)\s*ml\b/i); return m ? Number.parseFloat(m[1].replace(',', '.')) : 0; };
    const EPS = 0.01; /* pence per ml */
    const pricePerMl = (d) => {
      const rows = [];
      d.variants.forEach((v) => {
        let ml = 0;
        v.o.some((o) => (ml = mlOf(o)) > 0);
        if (!ml) ml = mlOf(v.t);
        if (!ml && d.variants.length === 1) ml = mlOf(d.title);
        if (ml > 0 && v.p > 0) {
          const same = rows.find((r) => r.ml === ml);
          const row = { ml, size: `${Math.round(ml * 10) / 10}ml`, price: v.p, per: v.p / ml };
          if (!same) rows.push(row); else if (row.per < same.per) Object.assign(same, row);
        }
      });
      rows.sort((a, b) => a.ml - b.ml);
      return rows;
    };
    /** Exposed for tests: index of the single best-value product, or -1 (none, or tied). */
    const bestValue = (list) => {
      const best = list.map((rows) => (rows.length ? Math.min(...rows.map((r) => r.per)) : 0));
      const priced = best.filter((b) => b > 0);
      if (priced.length < 2) return { best, winner: -1 };
      const min = Math.min(...priced);
      const winners = best.map((b, i) => (b > 0 && Math.abs(b - min) < EPS ? i : -1)).filter((i) => i > -1);
      return { best, winner: winners.length === 1 ? winners[0] : -1 };
    };

    /* ---------- the compare page ---------- */
    class ScenttComparePage extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-scentt-cmp-body]');
        this.status = this.querySelector('[data-scentt-cmp-status]');
        this.empty = this.querySelector('[data-scentt-cmp-empty]');
        this.error = this.querySelector('[data-scentt-cmp-error]');
        this.max = S.int(this.dataset.max, 3, 2, LIMIT);
        this.meter = S.oneOf(this.dataset.meter, ['bars', 'dots', 'words'], 'bars');
        this.estimate = this.dataset.estimate !== 'false';
        this.shop = safePath(this.dataset.shop, S.config.allUrl);
        let c = null;
        try { c = JSON.parse(this.dataset.conc || '{}'); } catch (e) { c = null; }
        this.conc = c && typeof c === 'object' && !Array.isArray(c) ? c : {};
        this.rows = Array.from(this.querySelectorAll('[data-scentt-cmp-row]')).slice(0, 30).map((li) => ({ type: li.getAttribute('data-scentt-cmp-row'), ...li.dataset }));
        if (!this.rows.length) {
          this.rows = ['price_ml', 'conc', 'longevity', 'strength', 'family', 'notes', 'for', 'occasion', 'season', 'sizes'].map((type) => ({ type, all: 'true', best: 'true', shared: 'true' }));
        }
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.off = picks.onChange(S.debounce(() => this.render(), 30));
        const b = bar();
        if (b && b.render) b.render();
        this.render();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.off) this.off();
        const b = bar();
        if (b && b.render) setTimeout(() => b.render());
      }

      t(key, value, token) {
        const s = String(this.dataset[key] || '');
        return token ? s.replace(token, () => String(value)) : s;
      }

      show(state, message) {
        if (this.status) this.status.hidden = state !== 'loading';
        if (this.empty) this.empty.hidden = state !== 'empty';
        if (this.error) {
          this.error.hidden = state !== 'error';
          const p = this.error.querySelector('[data-scentt-cmp-error-text]');
          if (p && message) p.textContent = message;
        }
        if (state !== 'table') this.body.replaceChildren();
      }

      async render() {
        const token = (this.token || 0) + 1;
        this.token = token;
        const handles = picks.all().slice(0, this.max);
        if (!handles.length) { this.show('empty'); return; }
        this.show('loading');
        const results = await Promise.all(handles.map(loadProduct));
        if (token !== this.token || !this.isConnected) return;
        const items = results.filter((r) => r.data).map((r) => r.data);
        const gone = handles.filter((h, i) => results[i].gone);
        const failed = results.some((r) => r.failed);
        if (!items.length) {
          if (failed) this.show('error', this.t('error'));
          else this.show('empty');
        } else {
          this.body.innerHTML = S.html`${this.table(items)}`;
          this.show('table');
        }
        if (gone.length) gone.forEach((h) => picks.remove(h)); /* deleted or unpublished products */
        S.emit('compare:render', { count: items.length });
      }

      levels(row, def) {
        const l = String(row.levels || '').split(',').map((x) => x.trim()).filter(Boolean);
        if (l.length === 5) return l;
        const d = String(this.dataset[def] || '').split(',').map((x) => x.trim());
        return d.length === 5 ? d : ['1', '2', '3', '4', '5'];
      }

      bars(n) {
        if (!n || this.meter === 'words') return '';
        const segs = [1, 2, 3, 4, 5].map((i) => H`<span class="scentt-meter__seg${i <= n ? ' is-on' : ''}"></span>`);
        return H`<span class="scentt-meter scentt-cmp__meter${this.meter === 'dots' ? ' scentt-meter--dots' : ''}" aria-hidden="true">${segs}</span>`;
      }

      table(items) {
        const NA = H`<span class="scentt-cmp__na">\u2014</span>`;
        const chips = (arr) => (arr.length ? arr.map((x) => H`<span class="scentt-cmp__chip">${x}</span>`) : NA);
        const cols = items.length;
        const more = cols < this.max;

        const ppm = items.map(pricePerMl);
        const priceRow = this.rows.find((r) => r.type === 'price_ml');
        const value = bestValue(ppm);
        const badgeOn = priceRow && priceRow.best !== 'false';

        const notesRow = this.rows.find((r) => r.type === 'notes');
        const shareOn = Boolean(notesRow && notesRow.shared !== 'false');
        const noteSets = items.map((d) => uniq([...d.top, ...d.heart, ...d.base, ...d.keyNotes]).map(norm));
        const shared = cols > 1 ? noteSets[0].filter((n) => noteSets.every((set) => set.includes(n))) : [];
        const notes = (arr) => (arr.length ? arr.map((n) => H`<span class="scentt-cmp__chip scentt-cmp__note${shareOn && shared.includes(norm(n)) ? ' is-shared' : ''}">${n}</span>`) : NA);

        const head = items.map((d, i) => {
          let btn;
          if (d.coming) btn = H`<button type="button" class="button button--secondary scentt-cmp__btn scentt-coming-btn" disabled>${this.t('coming')}</button>`;
          else if (!d.available) btn = H`<button type="button" class="button button--secondary scentt-cmp__btn" disabled>${this.t('soldout')}</button>`;
          else if (d.multi || !d.variant) btn = H`<a class="button button--secondary scentt-cmp__btn" href="${d.url}">${this.t('choose')}</a>`;
          else btn = H`<button type="button" class="button button--primary scentt-cmp__btn" data-scentt-cmp-add="${d.variant}">${this.t('add')}</button>`;
          const badge = badgeOn && value.winner === i ? H`<span class="scentt-badge scentt-cmp__badge">${priceRow.bestLabel || 'Best value'}</span>` : '';
          const img = d.image ? H`<img src="${d.image}" alt="${d.title}" width="300" height="300" loading="lazy">` : '';
          return H`<th scope="col" class="scentt-cmp__prod">
            <button type="button" class="scentt-cmp__x" data-scentt-cmp-remove="${d.handle}" aria-label="${this.t('remove', d.title, '[title]')}">\u00d7</button>
            <a class="scentt-cmp__img" href="${d.url}" tabindex="-1">${badge}${img}</a>
            ${d.vendor ? H`<span class="scentt-cmp__brand">${d.vendor}</span>` : ''}
            <a class="scentt-cmp__title" href="${d.url}" title="${d.title}">${d.title}</a>
            <span class="scentt-cmp__price">${d.compareAt ? H`<s>${d.compareAt}</s> ` : ''}${d.price}</span>
            ${btn}
          </th>`;
        });
        const moreCell = more ? H`<th scope="col" class="scentt-cmp__prod scentt-cmp__prod--more"><a href="${this.shop}" data-scentt-cmp-more><span aria-hidden="true">+</span>${this.t('more')}</a></th>` : '';

        const body = [];
        const row = (label, cells, cls = '') => {
          body.push(H`<tr class="${cls}"><th scope="row">${label}</th>${cells.map((c) => H`<td>${c}</td>`)}${more ? H`<td class="scentt-cmp__blank"></td>` : ''}</tr>`);
        };
        const money = (c) => S.money(Math.round(c));
        const perMl = (c) => this.t('perMl', money(c), '[price]');
        const conc = (d) => (this.conc[d.conc] && typeof this.conc[d.conc] === 'object' ? this.conc[d.conc] : null);
        const meterCell = (v, words, d, estimateWord) => {
          if (v > 0) return [this.bars(v), H`<span class="scentt-cmp__word">${words[v - 1] || ''}</span>`];
          const c = conc(d);
          const lv = c ? level(c.lv) : 0;
          if (this.estimate && lv) {
            return [this.bars(lv), H`<span class="scentt-cmp__word">${estimateWord(c, lv)}</span>`, H`<small>${this.t('typical', str(c.n, 80), '[name]')}</small>`];
          }
          return NA;
        };

        this.rows.forEach((r) => {
          switch (r.type) {
            case 'price_ml':
              row(r.label || 'Price per ml', items.map((d, i) => {
                const rows = ppm[i];
                if (!rows.length) return NA;
                const min = Math.min(...rows.map((x) => x.per));
                const cheapest = rows.find((x) => Math.abs(x.per - min) < EPS);
                if (r.all === 'false') {
                  return [H`<strong>${perMl(min)}</strong>`, rows.length > 1 ? H`<small>${this.t('bestOn', cheapest.size, '[size]')}</small>` : ''];
                }
                const varied = rows.some((x) => x.per - min > EPS);
                return rows.map((x) => H`<span class="scentt-cmp__ppm${varied && Math.abs(x.per - min) < EPS ? ' is-best' : ''}"><span>${x.size} \u00b7 ${money(x.price)}</span><strong>${perMl(x.per)}</strong></span>`);
              }));
              break;
            case 'price':
              row(r.label || 'Price', items.map((d) => [H`<strong>${d.price}</strong>`, d.compareAt ? H`<small><s>${d.compareAt}</s></small>` : '']));
              break;
            case 'conc':
              row(r.label || 'Concentration', items.map((d) => {
                const c = conc(d);
                const name = d.concLabel || (c ? str(c.n, 80) : '');
                return name ? [H`<strong>${name}</strong>`, c ? H`<small>${str(c.o, 80)}</small>` : ''] : NA;
              }));
              break;
            case 'longevity': {
              const words = this.levels(r, 'longevityLevels');
              row(r.label || 'Longevity', items.map((d) => meterCell(d.longevity, words, d, (c) => str(c.l, 60))));
              break;
            }
            case 'strength': {
              const words = this.levels(r, 'strengthLevels');
              row(r.label || 'Strength', items.map((d) => meterCell(d.strength, words, d, (c, lv) => words[lv - 1])));
              break;
            }
            case 'family': row(r.label || 'Fragrance family', items.map((d) => chips(d.family))); break;
            case 'notes':
              if (shareOn && shared.length) {
                const label = items[0] ? uniq([...items[0].top, ...items[0].heart, ...items[0].base, ...items[0].keyNotes]) : [];
                const names = shared.map((n) => label.find((x) => norm(x) === n) || titleCase(n));
                row(r.sharedLabel || 'Notes in common', items.map(() => names.map((n) => H`<span class="scentt-cmp__chip scentt-cmp__note is-shared">${n}</span>`)), 'scentt-cmp__row--shared');
              }
              row(r.top || 'Top notes', items.map((d) => notes(d.top)));
              row(r.heart || 'Heart notes', items.map((d) => notes(d.heart)));
              row(r.base || 'Base notes', items.map((d) => notes(d.base)));
              break;
            case 'for': row(r.label || 'Who it\u2019s for', items.map((d) => chips(d.forWho))); break;
            case 'occasion': row(r.label || 'Occasion', items.map((d) => chips(d.occasion))); break;
            case 'season': row(r.label || 'Season', items.map((d) => chips(d.season))); break;
            case 'sizes': row(r.label || 'Sizes', items.map((d) => chips(d.sizes))); break;
            case 'brand': row(r.label || 'Brand', items.map((d) => (d.vendor ? d.vendor : NA))); break;
            case 'availability':
              row(r.label || 'Availability', items.map((d) => (d.available
                ? H`<span class="scentt-cmp__ok">${this.t('inStock')}</span>`
                : H`<span class="scentt-cmp__na">${this.t('outOfStock')}</span>`)));
              break;
            case 'rating':
              row(r.label || 'Rating', items.map((d) => {
                if (!d.rating) return NA;
                const full = Math.round(d.rating);
                const stars = '\u2605\u2605\u2605\u2605\u2605'.slice(0, full) + '\u2606\u2606\u2606\u2606\u2606'.slice(0, 5 - full);
                const v = d.rating.toFixed(1);
                return [H`<span class="scentt-cmp__stars" role="img" aria-label="${this.t('rating', v, '[rating]')}">${stars}</span>`,
                  H`<small>${v}${d.ratingCount ? ` (${d.ratingCount})` : ''}</small>`];
              }));
              break;
            case 'metafield': {
              const key = String(r.key || '').trim();
              const display = S.oneOf(r.display, ['text', 'chips', 'meter'], 'text');
              const words = this.levels(r, 'strengthLevels');
              row(r.label || key, items.map((d) => {
                const v = (d.mf && Object.prototype.hasOwnProperty.call(d.mf, key) ? String(d.mf[key]) : '').trim();
                if (!v) return NA;
                if (display === 'meter') {
                  const n = level(v);
                  return n ? [this.bars(n), H`<span class="scentt-cmp__word">${words[n - 1]}</span>`] : v;
                }
                if (display === 'chips') return chips(split(v));
                return v.replace(/\|/g, ', ');
              }));
              break;
            }
            case 'tags': {
              const want = split(r.tags);
              row(r.label || 'Good to know', items.map((d) => {
                const have = d.tags.map(norm);
                const hit = want.filter((w) => have.includes(norm(w)));
                if (r.display === 'tick') return hit.length ? H`<span class="scentt-cmp__ok">\u2713 ${r.yes || 'Yes'}</span>` : NA;
                return chips(hit);
              }));
              break;
            }
            default: break;
          }
        });

        const legend = shareOn && shared.length
          ? H`<p class="scentt-cmp__legend"><span class="scentt-cmp__swatch" aria-hidden="true"></span>${this.t('legend')}</p>` : '';
        return H`${legend}<div class="scentt-cmp__scroll"><table class="scentt-cmp__table" style="--cols: ${cols + (more ? 1 : 0)};">
          <thead><tr><th scope="col" class="scentt-cmp__corner"><span class="visually-hidden">${this.t('fragrance')}</span></th>${head}${moreCell}</tr></thead>
          <tbody>${body}</tbody></table></div>`;
      }

      onClick(e) {
        const rm = e.target.closest('[data-scentt-cmp-remove]');
        if (rm) { picks.remove(rm.getAttribute('data-scentt-cmp-remove')); return; }
        if (e.target.closest('[data-scentt-cmp-retry]')) { this.render(); return; }
        const add = e.target.closest('[data-scentt-cmp-add]');
        if (!add || add.disabled) return;
        const id = add.getAttribute('data-scentt-cmp-add');
        if (!S.isId(id)) return;
        add.disabled = true;
        add.classList.add('loading');
        S.cart.add([{ id, quantity: 1 }])
          .then(() => {
            add.classList.remove('loading');
            add.classList.add('is-done');
            add.textContent = this.t('added');
            setTimeout(() => { add.classList.remove('is-done'); add.textContent = this.t('add'); add.disabled = false; }, 2500);
          })
          .catch(() => { add.classList.remove('loading'); add.disabled = false; /* Scentt.cart showed the message */ });
      }
    }
    ScenttComparePage.bestValue = bestValue;
    ScenttComparePage.pricePerMl = pricePerMl;
    customElements.define('scentt-compare-page', ScenttComparePage);
  };

  if (window.Scentt) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
